var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 394,
    height: 403,
    viewBox: "0 0 394 403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 394,
    height: 403
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -269.631, -266.467)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29 -149)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513,0,684,295.5,513,591H171L0,295.5,171,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.5767211914062 1 L 1.15533447265625 295.5 L 171.5764770507812 590 L 512.4222412109375 590 L 682.8446655273438 295.5 L 512.4222412109375 1 L 171.5767211914062 1 M 171.0000610351562 0 L 512.9989013671875 0 L 684 295.5 L 512.9989013671875 591 L 170.9998168945312 591 L 0 295.5 L 171.0000610351562 0 Z",
    stroke: "none",
    fill: "#e6d79c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.911 -280.613) rotate(30)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.168,0,682.89,295.675,512.168,591.35H170.723L0,295.675,170.723,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.2998657226562 1 L 1.1546630859375 295.6751708984375 L 171.2998657226562 590.350341796875 L 511.5906066894531 590.350341796875 L 681.7354736328125 295.6751708984375 L 511.5906066894531 1 L 171.2998657226562 1 M 170.7225952148438 0 L 512.1679077148438 0 L 682.89013671875 295.6751708984375 L 512.1679077148438 591.350341796875 L 170.7225952148438 591.350341796875 L 0 295.6751708984375 L 170.7225952148438 0 Z",
    stroke: "none",
    fill: "#e6d79c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 59.49, -227.801)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.167,0,682.89,295.675,512.167,591.35H170.722L0,295.675,170.723,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.2998352050781 1 L 1.15472412109375 295.6751403808594 L 171.2997436523438 590.3502807617188 L 511.5901489257812 590.3502807617188 L 681.7351684570312 295.6751403808594 L 511.5901489257812 1 L 171.2998352050781 1 M 170.7225341796875 0 L 512.16748046875 0 L 682.889892578125 295.6751403808594 L 512.16748046875 591.3502807617188 L 170.7224731445312 591.3502807617188 L 0 295.6751403808594 L 170.7225341796875 0 Z",
    stroke: "none",
    fill: "#e6d79c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.802 -194.146) rotate(8)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.167,0,682.89,295.675,512.167,591.35H170.722L0,295.675,170.723,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.2998352050781 1 L 1.15472412109375 295.6751403808594 L 171.2997436523438 590.3502807617188 L 511.5901489257812 590.3502807617188 L 681.7351684570312 295.6751403808594 L 511.5901489257812 1 L 171.2998352050781 1 M 170.7225341796875 0 L 512.16748046875 0 L 682.889892578125 295.6751403808594 L 512.16748046875 591.3502807617188 L 170.7224731445312 591.3502807617188 L 0 295.6751403808594 L 170.7225341796875 0 Z",
    stroke: "none",
    fill: "#e6d79c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.927, 0.375, -0.375, 0.927, 106.953, -255.881)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.168,0,682.89,295.675,512.168,591.35H170.723L0,295.675,170.723,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.2999267578125 1 L 1.1546630859375 295.6751708984375 L 171.2997436523438 590.350341796875 L 511.5904846191406 590.350341796875 L 681.7353515625 295.6751708984375 L 511.5904846191406 1 L 171.2999267578125 1 M 170.7225952148438 0 L 512.1677856445312 0 L 682.8900146484375 295.6751708984375 L 512.1677856445312 591.350341796875 L 170.7224731445312 591.350341796875 L -6.103515625e-05 295.6751708984375 L 170.7225952148438 0 Z",
    stroke: "none",
    fill: "#e6d79c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.d63befae2c4060ad784d881db09985b6.svg";
export { ForwardRef as ReactComponent };